import { render } from "./ai-number-box.vue?vue&type=template&id=cc02d3a8"
import script from "./ai-number-box.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-number-box.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ai-number-box.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cc02d3a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cc02d3a8', __exports__)) {
    api.reload('cc02d3a8', __exports__)
  }
  
  module.hot.accept("./ai-number-box.vue?vue&type=template&id=cc02d3a8", () => {
    api.rerender('cc02d3a8', render)
  })

}


export default __exports__